<template>
  <transition-fade :duration="500" appear>
    <main id="content" class="flex flex-col justify-end items-start mb-8">
      <box-generic
        v-if="hubCtas?.length"
        header="UITGELICHT"
        header-class="title-block bg-orange-500"
        class="ml-8 max-h-full"
      >
        <section class="grid grid-cols-1 auto-rows-fr gap-6">
          <template v-for="(cta, index) in hubCtas" :key="index">
            <div
              v-if="cta._rendered"
              :key="index"
              class="contents"
              v-html="cta._rendered"
            />
          </template>
        </section>
      </box-generic>
    </main>
  </transition-fade>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

import BoxGeneric from "../../components/content/BoxGeneric.vue";
import TransitionFade from "../../components/magic/TransitionFade.vue";

export default {
  name: "HubCtas",
  components: {
    BoxGeneric,
    TransitionFade,
  },
  setup() {
    const store = useStore();
    const hubCtas = computed(() => store.state.container?.hubCtas.slice(0, 3)); // show max 3 items
    return { hubCtas };
  },
};
</script>
